<template>
    <div class="text-dark">
        <b-form>
            <b-form-group label-cols="auto" label="Name">
                <b-form-input id="sessionName" v-model="session.sessionName" />
            </b-form-group>

            <b-form-group
                label-cols="auto"
                label="Number Of Hosts"
                label-for="numberOfHosts"
            >
                <b-form-spinbutton 
                id="numberOfHosts" 
                v-model="session.numberOfHosts"
                min="1"
                max="12"
                size="sm"
                inline
                />
            </b-form-group>

            <b-form-group
                label-cols="auto"
                label="Host Connection Only"
                label-for="isHostConnectionOnly"
            >
                <b-form-checkbox 
                id="isHostConnectionOnly" 
                v-model="session.isHostConnectionOnly"
                />
            </b-form-group>

            <!-- <b-form-group
                label-cols="auto"
                label="Host Must Admit"
                label-for="isHostMustAdmit"
            >
                <b-form-checkbox 
                id="isHostMustAdmit" 
                v-model="session.isHostMustAdmit"
                />
            </b-form-group> -->
        </b-form>
    </div>
</template>

<script>
export default {
    props: {
        session: {type: Object}
    },
};
</script>